import gql from 'graphql-tag';
import { networkGQLFields } from './network.fields.js';
export const addMemberSchemaFieldGQLMutation = (fields) => gql `
  mutation AddMemberSchemaField($input: CustomFieldSchemaInput!) {
    addMemberSchemaField(input: $input) {
      ${networkGQLFields(fields)}
    }
  }
`;
export const updateMemberSchemaFieldGQLMutation = (fields) => gql `
  mutation UpdateMemberSchemaField($input: UpdateCustomFieldSchemaInput!) {
    updateMemberSchemaField(input: $input) {
      ${networkGQLFields(fields)}
    }
  }
`;
export const archiveMemberSchemaFieldGQLMutation = (fields) => gql `
  mutation ArchiveMemberSchemaField($key: String!) {
    archiveMemberSchemaField(key: $key) {
      ${networkGQLFields(fields)}
    }
  }
`;
export const unArchiveMemberSchemaFieldGQLMutation = (fields) => gql `
  mutation UnArchiveMemberSchemaField($key: String!) {
    unArchiveMemberSchemaField(key: $key) {
      ${networkGQLFields(fields)}
    }
  }
`;
export const deleteMemberSchemaFieldGQLMutation = (fields) => gql `
  mutation DeleteMemberSchemaField($key: String!) {
    deleteMemberSchemaField(key: $key) {
      ${networkGQLFields(fields)}
    }
  }
`;
export const reorderMemberSchemaFieldsGQLMutation = (fields) => gql `
  mutation ReorderMemberSchemaFields($input: [ReOrderSchemaFieldInput!]!) {
    reorderMemberSchemaFields(input: $input) {
      ${networkGQLFields(fields)}
    }
  }
`;
//# sourceMappingURL=memberSchemaField.gql.js.map